import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { AppBar, Box, Grid, IconButton, Toolbar } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import clsx from 'clsx'
import { ReactComponent as LogoImg } from '../../../images/header/guildwell_logo.svg'
import { ReactComponent as AccountImg } from '../../../images/header/account_circle.svg'
import { NavigationDashboardTop } from '../Navigation'
import { AppStateContext } from '../../Context'
import { routes } from '../../../constants/routes'
import { MenuDashboard } from '../Menu'

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    position: 'relative',
    width: '100%',
    height: 72,
    background: theme.palette.info.main,
    boxShadow: 'none',
    padding: '0 32px',
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    paddingRight: '32px !important',
  },
  appBarOpen: {
    boxShadow: 'none',
  },
  appBarClose: {
    // background: '#46484E',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 1376,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    padding: 0,
    boxSizing: 'content-box',
  },
  menu: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'block',
    width: 129,
    maxWidth: '100%',
    height: 'auto',
    fill: theme.palette.primary.light,
    cursor: 'pointer',
  },
  accountImg: {
    opacity: '0.6',
    marginRight: '10px',
  },
  accountArrow: {
    opacity: '0.6',
    marginLeft: '10px',
  },
  userName: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.light,
    opacity: '0.87',
    fontSize: 14,
    lineHeight: 0,
    fontWeight: 400,
    letterSpacing: 0,
    textTransform: 'capitalize',
    paddingRight: theme.spacing(2),
  },
  burgerButton: {
    padding: 0,
    height: 'min-content',
  },
}))

export const HeaderDashboard: FC = () => {
  const { pathname } = useLocation()
  const history = useHistory()
  const classes = useStyles({ pathname })

  const [open, setOpen] = useState<boolean>(false)
  const { getUserName } = useContext(AppStateContext)
  const [userName, setUserName] = useState<string>()

  useEffect(() => setUserName(getUserName()), [setUserName, getUserName])

  const handleClickMenu = () => {
    setOpen(!open)
  }

  const handleLogo = useCallback(() => history.push(routes.TREASURY), [history])

  useEffect(() => {
    if (open) {
      setOpen(false)
    }
    // eslint-disable-next-line
  }, [pathname])

  return (
    <AppBar className={clsx(classes.appBar, !open ? classes.appBarOpen : classes.appBarClose)}>
      <Toolbar className={classes.toolbar}>
        <LogoImg className={classes.logo} onClick={handleLogo} />

        <Grid hidden={open}>
          <MenuDashboard />
        </Grid>

        <Box className={classes.menu}>
          {open ? (
            <NavigationDashboardTop />
          ) : (
            <Box className={classes.userName}>
              <AccountImg className={classes.accountImg} />
              {userName}
            </Box>
          )}

          <IconButton onClick={handleClickMenu} color="inherit" aria-label="menu" className={classes.burgerButton}>
            {!open ? <MenuIcon style={{ color: 'white' }} /> : <CloseIcon />}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
